export enum VirtualFrequencyValue {
  Annual = 1,
  Quarter = 3,
  Month = 4,
  Week = 7,
  Day = 5,
}

export interface IVirtualFrequencyProps {
  onChange?: (selection: (string | number)[]) => void;
  selection: (string | number)[];
  availableFrequencies: VirtualFrequencyValue[];
  isBulkSubscribtion: boolean;
}
